import { css } from "@emotion/react";
import styled from "@emotion/styled";
import type { CSSProperties } from "react";

import breakpoints from "@brexhq/shared/styles/breakpoints";
import { defineResponsiveSpacingVariable } from "@brexhq/shared/styles/spacing";
import { desktop, mobile } from "@brexhq/shared/types/SpacingScale";

export const DEFAULT_H_PADDING = "xlrg";
export const MOBILE_H_PADDING = "sml";
const H_PADDING_VAR = "--h-padding";

export const mainHPaddingStyles = css`
  ${defineResponsiveSpacingVariable(H_PADDING_VAR, DEFAULT_H_PADDING)}
  ${breakpoints.SML} {
    ${H_PADDING_VAR}: ${mobile[MOBILE_H_PADDING]}px;
  }
  padding-inline: var(${H_PADDING_VAR});
`;

export const MainHPadding = styled.div(mainHPaddingStyles);

const MIN_ASIDE_WIDTH = 300;
const MIN_MAIN_WIDTH = 400;
const H_GAP = "lrg";
const V_GAP = "xsml";

export const mainLayoutBreakpoint = `@media (max-width: ${
  MIN_ASIDE_WIDTH +
  MIN_MAIN_WIDTH +
  desktop[H_GAP] +
  2 * desktop[DEFAULT_H_PADDING]
}px)` as const;

export const MainLayout = styled(MainHPadding, {
  shouldForwardProp: (propName) =>
    propName !== "alignItems" && propName !== "as",
})<{
  alignItems?: CSSProperties["alignItems"];
}>`
  display: grid;
  ${defineResponsiveSpacingVariable("--v-gap", V_GAP)}
  ${defineResponsiveSpacingVariable("--h-gap", H_GAP)}
  gap: var(--v-gap) var(--h-gap);
  grid-template-columns: minmax(${MIN_MAIN_WIDTH}px, 2fr) minmax(
      ${MIN_ASIDE_WIDTH}px,
      1fr
    );
  align-items: ${({ alignItems }) => alignItems};

  ${mainLayoutBreakpoint} {
    grid-template-columns: minmax(100%, max-content);
  }

  > :empty {
    display: none;
  }

  &:has(> :empty) {
    grid-template-columns: minmax(100%, max-content);
  }
`;
